import { render } from "./TabNr1.vue?vue&type=template&id=666bad60&scoped=true"
import script from "./TabNr1.vue?vue&type=script&lang=js"
export * from "./TabNr1.vue?vue&type=script&lang=js"

import "./TabNr1.vue?vue&type=style&index=0&id=666bad60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666bad60"]])

export default __exports__